import { useTheme } from "@app/store/themeStore";
import { Chip, type ChipProps } from "@design-system/Inputs/Chip";
import { type FC, type Ref } from "react";
import { useTranslation } from "react-i18next";
import { RESOURCE_NAME, keys } from "./i18n";

export const ThemeTag: FC<
    ChipProps & {
        themeId: string;
        isTrigger?: boolean;
        disabled?: boolean;
        className?: string;
        size?: "sm" | "md";
        ref?: Ref<HTMLButtonElement>;
    }
> = ({
    themeId,
    isTrigger = false,
    disabled = false,
    className,
    size = "sm",
    ref,
    ...props
}) => {
    const currentTheme = useTheme(themeId);
    const { t } = useTranslation(RESOURCE_NAME);

    const value = currentTheme
        ? currentTheme?.name
        : isTrigger
          ? t(keys.select_theme)
          : t(keys.no_theme);
    return (
        <Chip
            className={className}
            size={size}
            interactive={isTrigger}
            disabled={disabled}
            ref={ref}
            {...props}
        >
            <Chip.Icon name="tagCircle" size="sm" color={currentTheme?.color} />
            <Chip.Value>{value}</Chip.Value>
            {isTrigger && <Chip.Icon name="chevronDown" />}
        </Chip>
    );
};
